import { Component, OnInit } from '@angular/core';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { WrapperComponent } from '@/app/components/projects/wrapper/wrapper.component';
import { FilterToolComponent } from '../../../../../../global/filter-tool/filter-tool.component';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-pqq-history',
  standalone: true,
  imports: [
    CommonModule,
    WrapperComponent,
    FilterToolComponent,
    MatMenuModule,
    MatIconModule,
  ],
  templateUrl: './pqq-history.component.html',
  styleUrl: './pqq-history.component.css',
})
export class PqqHistoryComponent implements OnInit {
  projectIdentifier: string;

  isCreate = false;
  currentDialog = 'PQQ';

  handleDialog() {
    this.isCreate = false;
    this.getPqqHistory();
  }

  tableData!: any;
  projectId: any;
  projectIdNew: any;
  private subscription: Subscription = new Subscription();

  constructor(
    private router: Router,
    private TenderingService: TenderingService,
    private projectsService: ProjectsService,
    private getProjectIdService: GetProjectIdService,
    private activatedRoute: ActivatedRoute
  ) {}

  projectName: string;

  ngOnInit(): void {
    this.projectId = this.getProjectIdService.getProjectId();
    this.activatedRoute.queryParams.subscribe((params) => {
      this.projectName = params['projectName'];
      this.projectIdentifier = params['projectIdentifier'];
    });
    this.tableData = this.getPqqHistory(); // Assign the observable directly
    this.getPqqHistory(); // Assign and process the data in getRiskRegisterData
    this.subscription = this.getProjectIdService.projectId$.subscribe((id) => {
      this.projectIdNew = id;
      if (!this.projectIdNew) {
        this.projectIdNew = this.getProjectIdService.getProjectId();
      }
      this.getPqqHistory();
    });
  }
  closeEoiSubmissions(eoi_id: any) {
    return this.projectsService.closeEOI(eoi_id).subscribe({
      next: (data: any) => {
        if (data) {
          this.getPqqHistory();
        }
      },
      error: (error) => {
        console.error('Error fetching projects:', error);
      },
    });
  }
  getPqqHistory(): any {
    return this.projectsService.getPqqSubmissions().subscribe({
      next: (data: any) => {
        this.tableData = data.data;
      },
      error: (error) => {
        console.error('Error fetching projects:', error);
      },
    });
  }

  formatDate(dateString: string): string | null {
    if (!dateString) return null;
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // Add leading zero
    const day = ('0' + date.getDate()).slice(-2); // Add leading zero

    return `${year}-${month}-${day}`;
  }

  openView(id: any) {
    this.TenderingService.setpqqId(id);
    this.router.navigate(['/initiate-pqq', this.projectId, id], {
      queryParams: { projectName: this.projectName, projectIdentifier: this.projectIdentifier },
    });
    this.TenderingService.setIsAppliedState(true);
  }

  handleCreatePQQ() {
    this.TenderingService.setProjectIdentifier(this.projectIdentifier);
    this.isCreate = true;
    localStorage.removeItem('eoi_id');
    localStorage.removeItem('pqqId');
    this.TenderingService.setEditState(false);
  }

  handleEdit(pqqId) {
    this.TenderingService.setProjectIdentifier(this.projectIdentifier);
    this.isCreate = true;
    this.TenderingService.setEditState(this.isCreate);
    this.TenderingService.setpqqId(pqqId);
  }
}
